import { useState } from 'react';
import { getParameter } from '../utils/helpers';

function useFilters() {
  const params = window.location.hash;

  const [selected, setSelected] = useState({
    countries: getParameter(params, 'countries', 'array') || [],
  });

  const [query, setQuery] = useState('');

  /**
   * Filtering function that does the heavy lifting in the app.
   *
   * @param {array} allPosts - All post objects loaded from WP data
   *
   * @return {array} - Array containing the filtered posts
   */

  const filterPosts = (allPosts) => {
    const { countries } = selected;
    let posts = [...allPosts];

    // filter by categories
    if (countries.length) {
      posts = posts.filter((post) => {
        return countries.includes(post.country);
      });
    }

    // filter by search query
    // if (query.length) {
    //   posts = posts.filter((post) => {
    //     const targets = [
    //       post.title,
    //     ];

    //     return targets.some((target) => {
    //       return target.toUpperCase().includes(query.toUpperCase());
    //     });
    //   });
    // }

    return posts;
  };

  return {
    selected,
    setSelected,
    query,
    setQuery,
    filterPosts,
  };
}

export { useFilters };
